import formatTimingPrefix from "./formatTimingPrefix";

const getLoginAppStartTime = () => {
    const timingPrefix = formatTimingPrefix();
    return sessionStorage.getItem(`${timingPrefix}loginAppStart`);
};

export default getLoginAppStartTime;
